import axios from 'axios'

export default {
  props: {
    // eslint-disable-next-line vue/require-default-prop
    djh: String,
    // eslint-disable-next-line vue/require-default-prop
    invoiceList: Array,
    // eslint-disable-next-line vue/require-default-prop
    invoiceDelArr: Array,
    // eslint-disable-next-line vue/require-default-prop
    view: String,
    // eslint-disable-next-line vue/require-default-prop,vue/prop-name-casing
    AccountingReview: Boolean,
    // eslint-disable-next-line vue/require-default-prop
    backFillBtn: Boolean
  },
  data() {
    return {
      files: [],
      invoiceArr: [],
      invoice: {
        vatInvoice: {},
        commodityList: []
      },
      multipleSelection: [],
      verificationBtn: false,
      verificationHistoryArr: [],
      verificationHistoryShow: false,
      verificationArr: [],
      verificationShow: false,
      verificationLabel: [
        { label: '发票号码', prop: 'invoiceNum', width: '80', aligin: 'center' },
        { label: '发票代码', prop: 'invoiceCode', aligin: 'center' },
        { label: '验证时间', prop: 'verificationTime', aligin: 'center' },
        { label: '验证结果', prop: 'verifyResult', width: '80', aligin: 'center' },
        { label: '验证次数', prop: 'verificationNum', width: '80', aligin: 'center' },
        { label: '验证人', prop: 'verificationUser', width: '80', aligin: 'center' },
        { label: '不含税金额', prop: 'totalAmount', width: '100', aligin: 'center' },
        { label: '税额', prop: 'totalTax', width: '80', aligin: 'center' },
        { label: '价税合计', prop: 'amountInFiguers', width: '80', aligin: 'center' }
      ],
      verificationHistoryLabel: [
        { label: '发票代码', prop: 'invoiceCode', width: '110', aligin: 'center' },
        { label: '发票号码', prop: 'invoiceNum', width: '110', aligin: 'center' },
        { label: '验证次数', prop: 'verificationNum', width: '80', aligin: 'center' },
        { label: '验证时间', prop: 'verificationTime', width: '140', aligin: 'center' },
        { label: '验证人', prop: 'verificationUser', width: '80', aligin: 'center' },
        { label: '验证结果返回码', prop: 'verifyResult', width: '110', aligin: 'center' },
        { label: '验证结果提示信息', prop: 'verifyMessage', aligin: 'center' }
      ],
      nuoVInvoiceTypes: [],
      map: new Map()
    }
  },
  created() {
    // 诺诺发票信息
    /*
    this.map.set('vat_special_invoice', '1')
    this.map.set('vat_electronic_special_invoice', '1')
    this.map.set('motor_vehicle_purchase_invoice', '1')
    this.map.set('vat_common_invoice', '2')
    this.map.set('vat_electronic_toll_common_invoice', '2')
    this.map.set('vat_electronic_common_invoice', '2')
    this.map.set('used_car_purchase_invoice', '3')
    this.map.set('vat_electronic_full_digital_invoice', '4')
    this.map.set('paper_electronic_full_invoice', '4')
    */

    this.invoiceArr = this.invoiceList
    this.verificationBtn = (this.view === 'view' || this.view === 'examine') && this.AccountingReview
    // 获取发票信息 百度云
    if (this.djh && this.djh !== '') {
      this.$post('/fesback/billManagement/getListByBill.z', { djh: this.djh }).then(res => {
        if (res.success) {
          if (res.data !== null && res.data !== '') {
            res.data.forEach(value => {
              if (value.type === 'vat_invoice') {
                if (value.checkCode && value.checkCode.length >= 6) {
                  value.checkCode = value.checkCode.substring(value.checkCode.length - 6)
                }
                if (value.verifyResult) {
                  value.verifyResult = value.verifyResult === '0001' ? '真' : value.verifyMessage
                }
              }

              value.fileUlr = 'https://www.wzyb.com.cn/pmpFile' + value.filePath
              if (value.filePath.indexOf('pdf') !== -1) {
                value.fileType = 'pdf'
                value.fileName = 'pdf预览'
              } else {
                value.fileType = 'image'
              }
            })
          }
          this.invoiceArr = res.data === null || res.data === '' || res.data === undefined ? [] : res.data
        }
      })
    }
    // 诺诺
    /*if (this.djh && this.djh !== '') {
      this.$post('/fesback/nuoOrc/findInvoiceDataSource.z', { djh: this.djh }).then(res => {
        if (res.data) {
          res.data.forEach(value => {
            if (this.map.has(value.invoiceType)) {
              value.amountInFiguers = value.priceTaxTotalFigure
              value.totalTax = value.taxAmountTotal
              value.totalAmount = value.noTaxAmountTotal
              value.checkCode = (value.checkCode && value.checkCode.length >= 6) ? value.checkCode.substring(value.checkCode.length - 6) : ''
              value.invoiceDate = value.invoiceDate ? value.invoiceDate.replace('年', '-').replace('月', '-').replace('日', '') : ''
              value.verifyResult = (value.verifyMessage && value.verifyMessage === '查验成功') ? '真' : value.verifyMessage
            }
          })
          this.invoiceArr = res.data
        }
      })
    }*/
  },
  methods: {
    // 百度云 验真
    verification() {
      const loading = this.$loading({
        lock: true,
        text: '验真中,请稍后...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const data = []
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        let legitimate = true
        let legitimate2 = true
        this.multipleSelection.forEach(value => {
          if (value.type !== 'vat_invoice') {
            legitimate = false
            return
          }
          if (!value.invoiceNum || !value.amountInFiguers || !value.invoiceDate ||
            !value.invoiceCode || !value.checkCode || value.checkCode === '') {
            legitimate2 = false
            return
          }
          const d1 = value
          d1.userName = localStorage.getItem('userName')
          d1.invoiceDate = value.invoiceDate.replace('年', '').replace('月', '').replace('日', '')
          data.push(JSON.stringify(d1))
        })
        if (!legitimate) {
          this.$message.error('只支持增值税发票验证,请重选！！！')
          loading.close()
          return
        }
        if (!legitimate2) {
          this.$message.error('发票信息不完整，不能进行验证。')
          loading.close()
          return
        }
        this.verificationArr = []
        this.$post('/fesback/invoice/invoiceVerification.z', { data: data }).then(res => {
          if (res.success) {
            res.data.forEach(item => {
              const arr = this.invoiceArr.filter(v => v.invoiceCode === item.code && v.invoiceNum === item.number)
              if (arr && arr.length > 0) {
                arr[0].verifyResult = item.verifyResult === '0001' ? '真' : item.verifyMessage
                arr[0].verifyFrequency = item.verifyFrequency
                arr[0].verifyMessage = item.verifyMessage

                const itemH = {
                  invoiceNum: arr[0].invoiceNum,
                  invoiceCode: arr[0].invoiceCode,
                  verificationUser: localStorage.getItem('userName'),
                  totalTax: arr[0].totalTax,
                  totalAmount: arr[0].totalAmount,
                  amountInFiguers: arr[0].amountInFiguers,
                  verificationTime: item.time,
                  verificationNum: item.verifyFrequency,
                  verifyResult: item.verifyResult === '0001' ? '真' : item.verifyMessage
                }
                this.verificationArr.push(itemH)
              }
            })
            this.verificationShow = true
            this.$message.success(res.message)
          } else {
            this.$message.error(res.message)
          }
          loading.close()
        })

      } else {
        this.$message.error('请选择数据')
        loading.close()
        return
      }
    },
    // 诺诺验真
    nuoVerification() {
      const loading = this.$loading({
        lock: true,
        text: '验真中,请稍后...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        let legitimate = true
        this.multipleSelection.forEach(value => {
          if (!this.map.has(value.invoiceType)) {
            legitimate = false
            return
          }
          if ('vat_common_invoice,vat_electronic_toll_common_invoice,vat_electronic_common_invoice'.indexOf(value.invoiceType) !== -1) {
            value.optionField = value.checkCode
          } else {
            value.optionField = value.amountInFiguers
          }
          value.userName = localStorage.getItem('userName')
          value.djh = this.djh
        })
        if (!legitimate) {
          this.$message.error('只支持增值税发票验证,请重选！！！')
          loading.close()
          return
        }
        this.verificationArr = []
        this.$post('/fesback/nuoOrc/invoiceVerification.z', this.multipleSelection).then(res => {
          res.data.forEach(item => {
            const arr = this.invoiceArr.filter(v => v.invoiceCode === item.invoiceCode && v.invoiceNum === item.invoiceNum)
            if (arr && arr.length > 0) {
              arr[0].verifyResult = item.verifyResult === '0000' ? '真' : item.verifyMessage
              const itemH = {
                invoiceNum: arr[0].invoiceNum,
                invoiceCode: arr[0].invoiceCode,
                verificationUser: localStorage.getItem('userName'),
                totalTax: arr[0].totalTax,
                totalAmount: arr[0].totalAmount,
                amountInFiguers: arr[0].amountInFiguers,
                verificationTime: item.verificationTime,
                verificationNum: item.verificationNum,
                verifyResult: item.verifyResult === '0000' ? '真' : item.verifyMessage
              }
              this.verificationArr.push(itemH)
            }
          })
          this.verificationShow = true
          this.$message.success(res.message)
          loading.close()
        })
      }
    },
    // 发票标识改为 待删除
    delDataArr() {
      const a = this.$refs['invoiceArr'].selection
      // 将待删除的发票信息 格式化
      const delInvoiceArr = []
      a.forEach(val => {
        if (val.newFile === '2') {
          delInvoiceArr.push(val)
        }
      })
      this.$emit('delInvoice', delInvoiceArr)
      a.forEach(data => {
        this.invoiceArr.splice(this.invoiceArr.indexOf(data), 1)
      })
      this.$emit('updateInvoice', this.invoiceArr)
    },
    // 回填
    backFill() {
      this.$emit('backFill', this.invoice.vatInvoice, this.invoice.commodityList)
    },
    // 查重
    duplicateCheck() {
      const loading = this.$loading({
        lock: true,
        text: '查重中,请稍后...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const duplicateArr = []
      this.multipleSelection.forEach(value => {
        if (!value.type !== 'others') {
          const item = {
            type: value.type,
            userName: localStorage.getItem('userName'),
            dcCode: value.invoiceCode,
            dcNum: value.invoiceNum,
            djh: value.djh
          }
          if (value.type === 'taxi_receipt') {
            item.invoiceCode = value.invoiceCode
            item.invoiceNum = value.invoiceNum
          }
          duplicateArr.push(JSON.stringify(item))
        }
      })

      // 百度云查重
      this.$post('/fesback/multipleInvoice/duplicateCheck.z', { data: duplicateArr }).then(res => {
        res.data.forEach(val => {
          let arr = []
          if (val.data.type === 'vat_invoice') {
            arr = this.invoiceArr.filter(v => v.invoiceCode === val.data.dcCode && v.invoiceNum === val.data.dcNum)
          }
          if (val.data.type === 'train_ticket') {
            arr = this.invoiceArr.filter(v => v.invoiceNum === val.data.dcNum)
          }
          if (val.data.type === 'air_ticket') {
            arr = this.invoiceArr.filter(v => v.invoiceNum === val.data.dcNum)
          }
          if (val.data.type === 'taxi_receipt') {
            arr = this.invoiceArr.filter(v => v.invoiceCode === val.data.invoiceCode && v.invoiceNum === val.data.invoiceNum)
          }
          console.log(val)
          if (val.data.type === 'quota_invoice') {

            arr = this.invoiceArr.filter(v => v.invoiceCode === val.data.dcCode && v.invoiceNum === val.data.dcNum)
          }

          if (arr && arr.length > 0) {
            this.$set(arr[0], 'duplicateSign', val.duplicate ? '2' : '1')
          }
        })
        this.$message.success(res.message + '表单对应信息已更新！')
        loading.close()
      }).catch(err => { this.$message.error(err) })
      // 诺诺 查重
      /*
      this.multipleSelection.forEach(value => {
        const item = {
          invoiceType: value.invoiceType
        }
      if (value.invoiceType === 'vat_electronic_common_invoice') {
        item.invoiceCode = value.invoiceCode
        item.invoiceNum = value.invoiceNum
      }
      if (value.invoiceType === 'train_ticket') {
        item.ticketNumber = value.invoiceNum
      }
      if (value.invoiceType === 'air_ticket') {
        item.ticketNum = value.invoiceNum
      }
      duplicateArr.push(item)
    })
      this.$post('/fesback/nuoOrc/duplicateCheck.z', duplicateArr).then(res => {
        res.data.forEach(val => {
          let arr = []
          if (val.invoiceType === 'vat_special_invoice') {
            arr = this.invoiceArr.filter(v => v.invoiceCode === val.invoiceCode && v.invoiceNum === val.invoiceNum)
          }
          if (val.invoiceType === 'train_ticket') {
            arr = this.invoiceArr.filter(v => v.invoiceNum === val.ticketNumber)
          }
          if (val.invoiceType === 'air_ticket') {
            arr = this.invoiceArr.filter(v => v.invoiceNum === val.ticketNum)
          }
          if (arr && arr.length > 0) {
            this.$set(arr[0], 'duplicate', val.duplicate)
          }
        })
        this.$message.success(res.message + '表单对应信息已更新！')
        loading.close()
      }).catch(err => { this.$message.error(err) })*/
    },
    // 大图预览
    handlePreview(row) {
      const a = document.createElement('a')
      const event = new MouseEvent('click')
      a.target = '_blank'
      // 百度 大图预览
      if (row.filePath && row.filePath !== '') {
        a.href = 'https://www.wzyb.com.cn/pmpFile' + row.filePath
      } else {
        a.href = window.URL.createObjectURL(row.file.raw)
      }
      // a.href = row.attachmentLink  // 诺诺大图预览
      a.dispatchEvent(event)
    },
    handleChange(file, fileList) {
      const fileName = file.name
      if (fileName === fileList[fileList.length - 1]) {
        this.$refs.upload.clearFiles()
      } else {
        let fileType = ''
        if (fileName.indexOf('.pdf') !== -1) {
          fileType = 'pdf'
        } else {
          fileType = 'image'
        }
        //获取最后一个.的位置
        const index = fileName.lastIndexOf('.')
        //获取后缀
        const ext = fileName.substr(index + 1)
        if ('jpg/jpeg/png/bmp'.indexOf(ext) !== -1 && file.size / 1024 / 1024 > 4) {
          const _this = this
          this.compress(file.raw, function(val) {
            file.raw = val
            file.size = val.size
            _this.vatInvoiceOrc(file, fileType)
          })
        } else {
          // 百度orc
          this.vatInvoiceOrc(file, fileType)
          // this.nuoOrc(file)  // 诺诺
        }
        this.$emit('updateInvoice', this.invoiceArr)
      }
      this.files = fileList
    },
    compress(fileObj, callback) {
      try {
        const image = new Image()
        image.src = URL.createObjectURL(fileObj)
        image.onload = function() {
          const that = this
          // 默认按比例压缩
          let w = that.width
          let h = that.height
          const scale = w / h
          w = fileObj.width || w
          h = fileObj.height || (w / scale)
          let quality = 0.7 // 默认图片质量为0.7
          // 生成canvas
          const canvas = document.createElement('canvas')
          const ctx = canvas.getContext('2d')
          // 创建属性节点
          const anw = document.createAttribute('width')
          anw.nodeValue = w
          const anh = document.createAttribute('height')
          anh.nodeValue = h
          canvas.setAttributeNode(anw)
          canvas.setAttributeNode(anh)
          ctx.drawImage(that, 0, 0, w, h)
          // 图像质量
          if (fileObj.quality && fileObj.quality <= 1 && fileObj.quality > 0) {
            quality = fileObj.quality
          }
          // quality值越小，所绘制出的图像越模糊
          const data = canvas.toDataURL(fileObj.type, quality)
          // 压缩完成执行回调
          const bytes = window.atob(data.split(',')[1]) // 去掉url的头，并转换为byte
          // 处理异常,将ascii码小于0的转换为大于0
          const ab = new ArrayBuffer(bytes.length)
          const ia = new Uint8Array(ab)
          for (let i = 0; i < bytes.length; i++) {
            ia[i] = bytes.charCodeAt(i)
          }
          const newFile = new File([ab], fileObj.name, { type: fileObj.type })
          callback(newFile)
        }
      } catch (e) {
        console.log('压缩失败!')
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 验证历史日志
    verificationHistory(row) {
      const data = {
        invoiceCode: row.invoiceCode,
        invoiceNum: row.invoiceNum
      }
      this.verificationHistoryArr = []
      this.$post('/fesback/invoice/verificationHistory.z', data).then(res => {
        this.verificationHistoryArr = res
        this.verificationHistoryShow = true
      })
    },
    invoiceArrReset() {
      this.invoiceArr = []
    },
    // 百度orc识别
    vatInvoiceOrc(file, fileType) {
      const formData = new FormData()
      formData.append(`files[${0}]`, file.raw)
      const loading = this.$loading({
        lock: true,
        text: '识别中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      axios.post('/fesback/multipleInvoice/multipleInvoice.z', formData).then(response => {
        const res = response.data
        if (res.success) {
          for (const element of res.data) {
            const itemData = element
            if (res.data.length > 1 && itemData.type === 'others') {
              continue
            }
            const t = {
              invoiceType: itemData.typeName,
              type: itemData.type,
              file: file,
              fileType: fileType,
              fileName: file.name,
              fileUlr: window.URL.createObjectURL(file.raw),
              data: itemData.data,
              newFile: '1'
            }
            const invoiceData = itemData.data
            if (itemData.type === 'vat_invoice') {
              if (JSON.stringify(this.invoice.vatInvoice) === '{}') {
                this.invoice.vatInvoice = invoiceData.vatInvoice
                this.invoice.commodityList = invoiceData.commodityList
              }
              t.invoiceNum = invoiceData.vatInvoice.invoiceNum
              t.amountInFiguers = invoiceData.vatInvoice.amountInFiguers
              t.invoiceDate = invoiceData.vatInvoice.invoiceDate
              t.invoiceCode = invoiceData.vatInvoice.invoiceCode
              t.checkCode = invoiceData.vatInvoice.checkCode
            }
            if (itemData.type === 'air_ticket') {
              const airTicket = invoiceData.airTicket
              t.invoiceNum = airTicket.flight
              t.amountInFiguers = airTicket.ticketRates
              t.invoiceDate = airTicket.startDate
              t.invoiceCode = airTicket.ticketNumber
              t.checkCode = airTicket.ck
            }
            if (itemData.type === 'train_ticket') {
              const trainTicket = invoiceData.trainTicket
              if (t.data.trainTicket && t.data.trainTicket.ticketRates) {
                t.data.trainTicket.ticketRates = this.invoiceJeFormat(t.data.trainTicket.ticketRates)
              }
              t.invoiceNum = trainTicket.trainNum
              t.amountInFiguers = trainTicket.ticketRates
              t.invoiceDate = trainTicket.date
              t.invoiceCode = trainTicket.ticketNum
              t.checkCode = trainTicket.serialNumber
            }
            if (itemData.type === 'taxi_receipt') {
              const taxiReceipt = invoiceData.taxiReceipt
              t.invoiceNum = taxiReceipt.invoiceNum
              t.amountInFiguers = taxiReceipt.totalFare
              t.invoiceCode = taxiReceipt.invoiceCode
              t.checkCode = taxiReceipt.serialNumber
            }
            if (itemData.type === 'quota_invoice') {
              const quotaInvoice = invoiceData.quotaInvoice
              t.invoiceNum = quotaInvoice.invoiceNumber
              t.amountInFiguers = quotaInvoice.invoiceRateInFigure
              t.invoiceCode = quotaInvoice.invoiceCode
              t.checkCode = quotaInvoice.serialNumber
            }
            // 价格格式统一处理
            if (t.amountInFiguers) {
              t.amountInFiguers = this.invoiceJeFormat(t.amountInFiguers)
            }
            const c = this.invoiceArr.filter(v => v.invoiceNum === t.invoiceNum && v.invoiceCode === t.invoiceCode)
            if (!c || c.length === 0 || itemData.type === 'others') {
              this.invoiceArr.push(t)
            } else {
              this.$message.error('当前发票已存在于本单据，请勿重复提交。')
              loading.close()
              return
            }
          }
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
        loading.close()
      }).catch(res => {
        this.$message.error('未知异常： ' + res)
        loading.close()
      })
    },
    // 金额格式化处理
    invoiceJeFormat(val) {
      if (val) {
        return val.replace('元', '').replace('￥', '')
      } else {
        return ''
      }
    },
    // 诺诺orc 识别
    nuoOrc(file) {
      const formData = new FormData()
      formData.append(`files[${0}]`, file.raw)
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      axios.post('/fesback/nuoOrc/multipleInvoice.z', formData).then(response => {
        const res = response.data
        if (res.success) {
          const description = res.data.description
          const t = {
            invoiceType: description,
            type: res.data.invoiceType,
            attachmentLink: res.data.attachmentLink,
            data: res.data
          }

          const data = res.data.data
          /*
          * 增值税专用发票、增值税普通发票、增值税电子普通发票、增值税电子普通发票（通行费）、增值税电子专用发票、通用电子发票
          * */
          if ((description.indexOf('增值税') !== -1 || description === '通用电子发票') && description !== '増值税卷式发票' && description !== '增值税电子发票 (其他增值税电子发票统称)') {
            this.invoice.vatInvoice = data
            t.invoiceNum = data.invoiceNum
            t.amountInFiguers = data.priceTaxTotalFigure
            t.invoiceDate = data.invoiceDate
            t.invoiceCode = data.invoiceCode
            t.checkCode = data.checkCode
          }
          this.invoiceArr.push(t)
        } else {
          this.$message.error(res.message)
        }
        loading.close()
      })

    },
    invoiceTypeFormatter(row) {
      if (row.description) {
        return row.description
      } else {
        return row.invoiceType
      }
    },
    invoiceCheck(row, name) {
      if ((name === '真伪' && row.verifyResult === '真') || (name === '查重' && row.duplicateSign === '1')) {
        return 'green'
      }
      return 'verifyMessageCss'
    },
    duplicateCheckSpan(val) {
      if (!val || val === '') {
        return ''
      } else if (val === '1') {
        return '发票已查重'
      } else if (val === '2') {
        return '发票已被使用，请核实后上传'
      }
    }

  }

}
